import React from 'react';
import Icon from '../../../icon';

interface SkillPillsProps {
  skills?: Array<{
    name: string;
    rating?: number | null;
    count?: number | null;
  }>;
  className?: string;
}

export function SkillPills({skills, className = ''}: SkillPillsProps) {
  if (!skills || skills.length === 0) return null;
  return (
    <div className={`flex flex-wrap gap-1 mt-1 ${className}`}>
      {skills.map((skill, index) => (
        <span
          key={`${skill.name}-${index}`}
          className="flex items-center  px-3 py-1 rounded-full bg-gray-200 text-gray-700 text-xs font-medium">
          {skill.rating && skill.rating > 6 && (
            <span className="flex items-center">
              <Icon name="star" className=" text-yellow-500" />
              <span className="ml-0.5 mr-1 text-gray-800 font-bold">
                {skill.rating.toFixed(0)}
              </span>
            </span>
          )}
          {skill.name}
        </span>
      ))}
    </div>
  );
}
